import { atom, selector } from 'recoil';

import goodApi from '@bo-apis/good/goodApi';
import codeApi from '@bo-apis/system/codeApi';

export const mainStdCategoryState = atom({
  key: 'mainStdCategoryState',
  default: selector({
    key: 'defaultMainStdCategory',
    get: async () => {
      const { result } = await goodApi.getMainStdCategory({ skipSpinner: true });
      return result;
    },
  }),
});

export const exhibitionCategoryState = atom({
  key: 'exhibitionCategoryState',
  default: selector({
    key: 'defaultExhibitionCategoryState',
    get: async () => {
      const { result } = await codeApi.getCodeDetailList('PR1009', { skipSpinner: true });
      return result;
    },
  }),
});

export const displayMainFunction = atom({
  key: 'displayMainFunction',
  default: [],
});
